import { theme } from 'antd';
import SuperFetch from 'library/helpers/superFetch';
import fieldsValidator from 'library/helpers/validators/fieldsValidator';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectWorkspaceByID } from 'reduxStore/organisations/selectors';
import { Notification } from 'zComponents/atoms';
import { Button, Col, Form, Input, Modal, Row, Typography } from 'zui/Antd';

const { Title, Text, Link } = Typography;

const BuySmartLocksModal = ({ visible, setVisible }) => {
	// ✅ Hooks
	const {
		token: {
			paddingXL,
			fontSizeSM,
			colorPrimary,
			paddingLG,
			colorTextDescription,
			fontWeightStrong,
			marginLG,
			paddingSM
		}
	} = theme.useToken();
	const [form] = Form.useForm();

	// ✅ Redux State
	const person = useSelector((state) => state.Auth.selectedProfile);
	const workspace = useSelector((state) => selectWorkspaceByID(state, person.orgID));

	useEffect(() => {
		if (visible) {
			form.setFieldsValue({
				fullName: person.displayName || `${person.firstName} ${person.lastName}` || '',
				email: person.email,
				workspace: workspace.name || ''
			});
		}
	}, [visible, form, person, workspace]);

	// ✅ Local States
	const [loading, setLoading] = useState(false);

	// ✅ Close modal
	const handleCancel = () => {
		form.resetFields();
		setVisible(false);
	};

	const handleSubmit = async (values) => {
		setLoading(true);

		const inquiry = `
            🚀 *Smart Lock Inquiry* 🚀

            👤 Full Name: ${values.fullName}
            🏢 Company: ${values.workspace}
            📧 Email: ${values.email}
            📞 Phone: ${values.phone}
            🔐 Smart Locks Requested: ${values.notes}

            Requested by: ${person.displayName || `${person.firstName} ${person.lastName}`}
            Org ID: ${person.orgID}
        `;

		const data = {
			personID: person.personID,
			orgID: person.orgID,
			inquiry: inquiry
		};

		try {
			const res = await SuperFetch.post('/access/inquiryEmail', {
				data
			});
			if (res.statusCode === 200) {
				Notification('success', 'Your inquiry has been sent successfully.');
			} else {
				throw new Error('There is an Error! We are mending the problem, try again soon!.');
			}
		} catch (error) {
			Notification('error', error);
		}
		handleCancel();
		setLoading(false);
	};

	return (
		<Modal
			open={visible}
			onCancel={handleCancel}
			footer={[
				<Row
					justify='end'
					gutter={paddingSM}
					style={{
						marginTop: marginLG
					}}
				>
					<Col>
						<Button onClick={handleCancel} disabled={loading}>
							Cancel
						</Button>
					</Col>
					<Col>
						<Button
							form={form}
							key='submit'
							htmlType='submit'
							type='primary'
							disabled={loading}
							loading={loading}
						>
							Send Request
						</Button>
					</Col>
				</Row>
			]}
			width={600}
			destroyOnClose
			styles={{ content: { padding: paddingXL } }}
		>
			<Row gutter={[paddingLG, paddingLG]}>
				<Col span={24}>
					<Title level={4} style={{ margin: 0 }}>
						Buy Smart Locks
					</Title>
					<Text
						style={{
							fontSize: fontSizeSM,
							lineHeight: '20px',
							color: colorTextDescription
						}}
					>
						Purchase Zezamii’s smart locks for your workspace to experience{' '}
						<Link
							href='#'
							style={{ color: colorPrimary, fontSize: fontSizeSM, fontWeight: fontWeightStrong }}
						>
							seamless security
						</Link>{' '}
						with{' '}
						<Link
							href='#'
							style={{ color: colorPrimary, fontSize: fontSizeSM, fontWeight: fontWeightStrong }}
						>
							smart access
						</Link>
						.
					</Text>
				</Col>
				<Col span={24}>
					<Form id={form} form={form} layout='vertical' onFinish={handleSubmit}>
						<Row gutter={16}>
							<Col span={12}>
								<Form.Item
									name='fullName'
									label='Full Name'
									rules={fieldsValidator.Name}
									style={{
										fontWeight: fontWeightStrong
									}}
									required={false}
								>
									<Input placeholder='First Name Last Name' />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									name='workspace'
									label='workspace'
									rules={fieldsValidator.Name}
									style={{
										fontWeight: fontWeightStrong
									}}
									required={false}
								>
									<Input placeholder='workspace Name' />
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={16}>
							<Col span={12}>
								<Form.Item
									name='email'
									label='Email'
									rules={fieldsValidator.Email}
									style={{
										fontWeight: fontWeightStrong
									}}
									required={false}
								>
									<Input placeholder='Email Address' />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									name='phone'
									label='Phone'
									rules={fieldsValidator.Mobile}
									style={{
										fontWeight: fontWeightStrong
									}}
									required={false}
								>
									<Input placeholder='Mobile Number' />
								</Form.Item>
							</Col>
						</Row>
						<Row>
							<Form.Item
								name='notes'
								label='Details'
								rules={fieldsValidator.Description}
								style={{
									fontWeight: fontWeightStrong,
									width: '100%'
								}}
								required={false}
							>
								<Input.TextArea />
							</Form.Item>
						</Row>
					</Form>
				</Col>
			</Row>
		</Modal>
	);
};

export default BuySmartLocksModal;
